module.exports = __webpack_public_path__ + "media/images/front/sns/x_logo-bf0e01a80d9444f15a32f593676f8888.png";